<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import AssistantPlayground from 'dashboard/components-next/captain/assistant/AssistantPlayground.vue';

const route = useRoute();
const assistantId = computed(() => Number(route.params.assistantId));
</script>

<template>
  <AssistantPlayground :assistant-id="assistantId" />
</template>
